import { Injectable } from "@angular/core";
import { ProjectClient } from "../api";
import { ICerViewComponent } from "@form/cer-form-view";
import { CerPromptService } from "@ui/cer-ui-prompt.service";

@Injectable({ providedIn: 'root' })
export class ProjectTaskService {

  constructor(private projectClient: ProjectClient, private ui: CerPromptService) {
  }

  public taskClose(row: any, taskComponent: ICerViewComponent) {
    if (row != null && row.id) {
      this.taskCloseByTaskId(row.id, taskComponent);
    }
  }

  private taskCloseByTaskId(taskId: number, taskComponent: ICerViewComponent) {
    if (taskId != null) {
      this.projectClient.taskClose(taskId).subscribe({
        next: (count) => {
          if (count > 0 && taskComponent != null) {
            taskComponent.research();
            this.ui.toast(count + ' opgave afsluttet');
          }
        }
      });
    }
  }

  public taskContactsCreate(row: any, contactComponent: ICerViewComponent) {
    if (row != null && row.product) {
      this.taskContactsCreateByTaskId(row.id, contactComponent);
    }
    else {
      this.ui.toast('Vælg en opgave med en udgivelse for at oprette kontakter');
    }
  }

  private taskContactsCreateByTaskId(taskId: number, contactComponent: ICerViewComponent) {
    if (taskId != null) {
      this.projectClient.taskContactsCreate(taskId).subscribe({
        next: (count) => {
          if (count > 0 && contactComponent != null) {
            contactComponent.research();
          }
        }
      });
    }
  }

/*
  public editDescription(grid: CerGridComponent, description$: BehaviorSubject<string>) {
    if (grid != null) {
      var data: any = grid.rowSelectedData();
      if (data?.id != null) {
        grid.disable();

        var config = <MatDialogConfig>{ width: '800px', height: '500px', maxWidth: '95vw', maxHeight: '95vh', data: { html: data.description }, panelClass: 'resizable-mat-dialog-panel' };
        var dialogRef: MatDialogRef<ProjectTaskDocComponent> = this.dialog.open(ProjectTaskDocComponent, config);
        dialogRef.afterClosed().subscribe(result => {
          grid.enable();
          if (result.dataChanged) {
            description$.next(result.html);
            data.description = result.html;
            grid.grid.setCellValue(data.id, 'description', result.html);
            var dm: DataManager = <DataManager>grid.grid.dataSource;
            dm.update(data.id, data);
          }
        });
      }
    }
  }
    */
}